export default __webpack_public_path__ + "img/7fd1faf0b4b302d4b0cb34a719793f56.png";